/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentProviders/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Accounts from './Accounts/index'
import AddAction from './AddAction/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import LocationSelect from './LocationSelect/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PaymentProviders({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="PaymentProviders.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-ZwXTSM': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<LocationSelect
  viewPath={`${viewPath}/LocationSelect`}
/>
<div
  data-testid="PaymentProviders.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-2-ZwXTSM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PaymentProviders.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Payment providers"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Setup Bluefin or Payabli payment accounts information."
/>
</div>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<div
  data-testid="PaymentProviders.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="PaymentProviders.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 size="large"
 weight="medium"
 text="Active Providers"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 color={dtColorsNeutral500}
 text="Providers that can be used for payments are listed below. You can set one of them as default"
/>
<Accounts
  viewPath={`${viewPath}/Accounts`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}